import React from 'react';

import PropTypes from 'prop-types';

import {
    Button,
    Glyphicon,
} from 'reaxl';

function HideAdButton({ onClick, text = 'Hide' }) {
    return (
        <Button
            bsStyle="text"
            bsSize="small"
            className="display-flex padding-0 text-size-100"
            onClick={onClick}
        >
            {text}
            <Glyphicon
                aria-label="hide-advertisement"
                glyph="remove"
                className="text-blue text-size-300"
            />
        </Button>
    );
}

HideAdButton.propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.string,
};

export default HideAdButton;
